import { Notice } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { Alarm } from '@phosphor-icons/react';

interface SeatsLeftInfoProps {
  numberOfSeatsLeft: number;
}

const SeatsLeftInfo = ({ numberOfSeatsLeft }: SeatsLeftInfoProps) => {
  const { t } = useTranslation();
  const numberOfseatsLeftLabel =
    numberOfSeatsLeft > 1
      ? t('Air.Result.NumberOfSeatsLeft', numberOfSeatsLeft)
      : t('Air.Result.OneSeatLeft', numberOfSeatsLeft);

  return (
    <Notice
      icon={
        <Alarm aria-hidden="true" data-testid="alarm-seats-left-icon" size={20} weight="bold" />
      }
      variant="promotional"
    >
      {numberOfseatsLeftLabel}
    </Notice>
  );
};

export default SeatsLeftInfo;
